import { render, staticRenderFns } from "./homeCertificate.vue?vue&type=template&id=f6db8d3e&scoped=true&"
import script from "./homeCertificate.vue?vue&type=script&lang=js&"
export * from "./homeCertificate.vue?vue&type=script&lang=js&"
import style0 from "./homeCertificate.vue?vue&type=style&index=0&id=f6db8d3e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6db8d3e",
  null
  
)

export default component.exports